import 'slick-carousel'
import $ from 'jquery'

export default function() {
    let container = document.querySelector('.section-2 .slick-container')
    function createSlider() {
        $(container).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            rows: 0,
            centerPadding: '10px',
            infinite: false,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 635,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 465,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        })
    }

    if(window.matchMedia("(max-width: 1366px)").matches && container) {
        createSlider()
    }
}